import { post, get } from "@/request/http";


//  获取显示数据
export const getwebNews = p => get("/center/getNewsList", p);
//新增新闻
export const saveNews = p => get("/center/saveNews", p);

//置顶
export const handleTop = p => get("/center/handleTop", p);



//删除
export const deleteNews = p => get("/center/deleteNews", p);


//更新排序
export const updateNewsSort = p => get("/center/updateNewsSort", p);

//编辑新闻
export const getNewsInfo = p => get("/center/getNewsInfo", p);


//更新新闻
export const updateNews = p => post("/center/updateNews", p);
